<div #container [ngClass]="'p-contextmenu p-component ui-corner-all ui-shadow'" [class]="styleClass" [ngStyle]="style">
  <iu-prime-contextMenuSub [item]="model" [parentActive]="parentActive" root="root"></iu-prime-contextMenuSub>
</div>
